/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'

import { SkeletonRow } from 'src/components/ts-components/SkeletonBlock'

const CARD_COUNT = 5
const CARD_HEIGHT = 120

/** Cold-load placeholder for the Recent Games cards. */
const RecentGamesSkeleton = () => {
  'use memo'

  return (
    <div aria-hidden='true' css={gridStyles}>
      {Array.from({ length: CARD_COUNT }, (_, i) => (
        <SkeletonRow key={i} height={CARD_HEIGHT} />
      ))}
    </div>
  )
}

// ─── Styles ──────────────────────────────────────────────────────

/**
 * `auto-fill` keeps the empty columns, so two or three games sit side by side
 * at a normal card width instead of spreading across the row. The 224px
 * minimum makes the full-width (1280px) column exactly five tracks, so five
 * games still fill it.
 */
const gridStyles = css`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(224px, 1fr));
  gap: 12px;
`

export default RecentGamesSkeleton
